@let mapConfigString = JSON.stringify(resourcesService.mapConfig.value()) ;
@let texts = resourcesService.languageFile.value();
@let answerLegendUrl = store.answerLegendUrl();
@let isModalOpen = store.isInfoModalOpen() || !!store.error();
@if (mapConfigString) {
  <div id="inner-map-container">
    @if (answerLegendUrl) {
      <div class="legend-container" [class.hidden]="isModalOpen">
        <div class="legend-header">{{ texts.legend }}</div>
        <img [src]="answerLegendUrl" [alt]="texts.legend">
      </div>
    }
    <gm-map
      id="map"
      [attr.json]="mapConfigString"
      options='{ "onlyAddVisibleLayers": true }'
      shared
      map_z="1"
      >
    </gm-map>
    <div #info id="info"></div>
  </div>
}
